import { render, staticRenderFns } from "./RecordsPanel.vue?vue&type=template&id=bbe7913a&"
import script from "./RecordsPanel.vue?vue&type=script&lang=js&"
export * from "./RecordsPanel.vue?vue&type=script&lang=js&"
import style0 from "./RecordsPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports